import { t } from "i18next";
import { z } from "zod";

import { documentsUploadSchema } from "src/core/forms/folder/documentsUpload.schema";
import { dateOfBirthRule, nameRule } from "src/core/forms/validators/rules";
import { FolderFileQuery } from "src/core/gql/graphql";
import { getFolderFieldValue } from "src/core/mappers/folder.mapper";

export const updateEntrepreneurSchema = () =>
  z.object({
    title: z.string().optional(),
    firstName: nameRule(t, { checkIfShown: true, required: true }),
    birthName: nameRule(t, { checkIfShown: true }),
    lastName: nameRule(t, { checkIfShown: true, required: true }),
    citizenshipCountryCode: z.string().optional(),
    birthDate: dateOfBirthRule(t, { checkIfShown: true, required: true }),
    residenceCountryCode: z.string().optional(),
    birthCountryCode: z.string().optional(),
    birthPlace: z.string().optional(),
    registration: z.string().optional(),
    activityCode: z.string().optional(),
    personLegalFormCode: z.string().optional(),
    customString1: z.string().optional(), // code postal
    customString2: z.string().optional(), // adresse
    customCountryCode1: z.string().optional(), // pays
    documents: documentsUploadSchema(t),
  });
export type UpdateEntrepreneurFormValues = z.infer<ReturnType<typeof updateEntrepreneurSchema>>;

export const defaultUpdateEntrepreneurValues = (
  folderFile: FolderFileQuery
): UpdateEntrepreneurFormValues => {
  return {
    title: getFolderFieldValue(folderFile, "title"),
    firstName: getFolderFieldValue(folderFile, "firstName"),
    birthName: getFolderFieldValue(folderFile, "birthName"),
    lastName: getFolderFieldValue(folderFile, "lastName"),
    citizenshipCountryCode: getFolderFieldValue(folderFile, "citizenshipCountryCode"),
    birthDate: getFolderFieldValue(folderFile, "birthDate"),
    residenceCountryCode: getFolderFieldValue(folderFile, "residenceCountryCode"),
    birthCountryCode: getFolderFieldValue(folderFile, "birthCountryCode"),
    birthPlace: getFolderFieldValue(folderFile, "birthPlace"),
    registration: getFolderFieldValue(folderFile, "registration"),
    activityCode: getFolderFieldValue(folderFile, "activityCode"),
    personLegalFormCode: getFolderFieldValue(folderFile, "personLegalFormCode"),
    customString1: getFolderFieldValue(folderFile, "customString1"),
    customString2: getFolderFieldValue(folderFile, "customString2"),
    customCountryCode1: getFolderFieldValue(folderFile, "customCountryCode1"),
    documents: {},
  };
};
